module.exports = __webpack_public_path__ + "img/vi.f8f3cfb5.png";